import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {
  ListItem, Typography,
  withStyles
} from '@material-ui/core';

import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import InboxIcon from '@material-ui/icons/Inbox';
import { connect } from 'react-redux';
import CategoryApi from '../../../utils/apiManager/constrollers/categoryApi';
import { deleteCategory, renameCategory } from '../../../redux/reducers/categories/actions';
import { getActiveCategory } from '../../../redux/reducers/images/selectors';
import MenuItemCustom from './MenuItemCustom';

const styles = (theme) => ({
  item: {
    display: 'flex',
    paddingTop: 0,
    paddingBottom: 0,
  },
  button: {
    display: 'flex',
    minHeight: '48px',
    textDecoration: 'none',
    justifyContent: 'flex-start',
    flexFlow: 'row',
    color: theme.palette.text.secondary,
    fontSize: '1rem',
    fontWeight: theme.typography.fontWeightMedium,
    letterSpacing: 0,
    padding: '10px 8px',
    margin: '6px 0 6px 0',
    textTransform: 'none',
    width: '100%',
    transition: 'none',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#f4f6f8',
    }
  },
  menuBtn: {
    display: 'flex',
    justifyContent: 'flex-start',
    flexFlow: 'row',
    color: theme.palette.text.secondary,
    fontSize: '1rem',
    fontWeight: theme.typography.fontWeightMedium,
    letterSpacing: 0,
    padding: '10px 8px',
    margin: '6px 0 6px 0',
    textTransform: 'none',
    width: '100%',
    transition: 'none',
    cursor: 'pointer',
    backgroundColor: '#f4f6f8',
  },
  icon: {
    marginRight: theme.spacing(1),
    fontSize: '1.5rem',
    margin: '0 0 0 18px'
  },
  iconOptions: {
    margin: '0 0 0 -10px'
  },
  title: {
    fontWeight: theme.typography.fontWeightMedium,
    color: '#000',
    backgroundColor: 'transparent',
    fontSize: '1rem',
    padding: '1px 0 0 7px',
    border: 0,
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    maxWidth: '180px',
  },
  active: {
    color: theme.palette.primary.main,
    '& $title': {
      fontWeight: theme.typography.fontWeightMedium
    },
    '& $icon': {
      color: theme.palette.primary.main
    }
  },
  iconAddFolder: {
    position: 'relative',
    margin: '-1px 0 0 0',
    padding: 0,
    fontSize: 20
  }
});

class NavItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      anchorEl: null,
      setAnchorEl: null,
      style: { display: 'none' },
      renameCatInputDisabled: true,
      delAlert: false,
    };
    this.inputRef = React.createRef();
    this.handleClick = this.handleClick.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.renameCategory = this.renameCategory.bind(this);
    this.handleRenameCategory = this.handleRenameCategory.bind(this);
    this.handleDeleteCategory = this.handleDeleteCategory.bind(this);
    this.activateRenamingInput = this.activateRenamingInput.bind(this);
    this.handleClickDeletionAlertOpen = this.handleClickDeletionAlertOpen.bind(this);
    this.handleDeletionAlertClose = this.handleDeletionAlertClose.bind(this);
  }

  async componentDidMount() {
    this.categoryApi = await CategoryApi.getInstance();
  }

  handleClick(event) {
    event.preventDefault();
    this.setState({
      anchorEl: event.currentTarget,
    });
  }

  handleClose() {
    this.setState({
      anchorEl: null,
    });
  }

  async renameCategory(value) {
    try {
      await this.categoryApi.renameCategory(value, this.props.id);
      this.props.renameCategory({
        id: this.props.id,
        groupId: this.props.groupId,
        title: value,
      });
    } catch (e) {
      document.getElementById(`${this.props.id}renameInput`).value = this.props.title;
    }
  }

  async handleRenameCategory(event) {
    if (event.key === 'Enter') {
      event.preventDefault();
      await this.renameCategory(event.target.value);
      this.setState({
        renameCatInputDisabled: true,
      });
    } else if (event.key === 'Escape') {
      document.getElementById(`${this.props.id}renameInput`).value = this.props.title;
      this.setState({
        renameCatInputDisabled: true,
      });
    }
  }

  async handleDeleteCategory() {
    const isDeleted = await this.categoryApi.deleteCategory(this.props.id);
    if (isDeleted) {
      this.props.deleteCategory(this.props.id, this.props.groupId);
    }
  }

  activateRenamingInput() {
    this.setState({ renameCatInputDisabled: false }, () => {
      this.inputRef.current.focus();
    });
  }

  handleClickDeletionAlertOpen() {
    this.setState({ delAlert: true });
  }

  handleDeletionAlertClose() {
    this.setState({ delAlert: false });
  }

  render() {
    const {
      classes,
      className,
      icon: Icon,
      title,
      count,
    } = this.props;

    return (
      <ListItem
        className={clsx(classes.item, className)}
        disableGutters
        onMouseEnter={() => {
          this.setState({ style: { display: 'block' } });
        }}
        onMouseLeave={() => {
          this.setState({ style: { display: 'none' } });
        }}
      >
        <RouterLink
          activeClassName={classes.active}
          className={classes.button}
          style={{
            display: 'inherit',
            backgroundColor: this.props.categoryId === this.props.id ? '#f7f7f7' : '',
          }}
          to={`/app/dashboard/${this.props.groupId}/${this.props.id}`}
        >
          {Icon && (
            <InboxIcon
              className={classes.icon}
              size="20"
            />
          )}
          <span style={{ position: 'relative' }}>
            <input
              ref={this.inputRef}
              id={`${this.props.id}renameInput`}
              type='text'
              className={classes.title}
              defaultValue={title}
              onKeyDown={this.handleRenameCategory}
              onBlur={() => {
                this.setState({
                  renameCatInputDisabled: true,
                });
                document.getElementById(`${this.props.id}renameInput`).value = this.props.title;
              }}
              disabled={this.state.renameCatInputDisabled}
              style={{
                cursor: this.state.renameCatInputDisabled ? 'pointer' : 'auto',
              }}
            />
            <span style={{
              display: this.state.renameCatInputDisabled ? 'block' : 'none',
              position: 'absolute',
              left: 0,
              right: 0,
              top: 0,
              bottom: 0,
            }} />
          </span>
          <Typography
            style={{ marginRight: '10px', paddingTop: '2px' }}
          >
            {count || 0}
          </Typography>
          <div
            style={this.state.style}
          >
            <MenuItemCustom
              id={this.props.id}
              items={[
                {title: 'Rename', onCustomClick: this.activateRenamingInput},
                {title: 'Delete', onCustomClick: this.handleClickDeletionAlertOpen},
              ]}
            />
          </div>
        </RouterLink>
        <Dialog
          open={this.state.delAlert}
          onClose={this.handleDeletionAlertClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            Are you sure that you want to delete
            {' '}
            <b>{title}</b>
            {' '}
            category?
          </DialogTitle>
          <DialogActions>
            <Button onClick={this.handleDeletionAlertClose} color="primary">
              Cancel
            </Button>
            <Button onClick={this.handleDeleteCategory} color="primary" autoFocus>
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      </ListItem>
    );
  }
}

NavItem.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  href: PropTypes.string,
  icon: PropTypes.elementType,
  title: PropTypes.string,
  deleteCategory: PropTypes.func,
  renameCategory: PropTypes.func
};

export default connect(
  getActiveCategory,
  { deleteCategory, renameCategory }
)(withStyles(styles)(NavItem));
